export const capitalize = (toChange: string) => (toChange ? toChange[0].toUpperCase() + toChange.slice(1) : '');
